/* German (Germany) */

export default {
  "Selected": "Ausgewählt",
  "Clear": "Löschen",
  "Search": "Suchen",
  "No results found": "Keine Ergebnisse gefunden",
  "Date-range": "Datumsbereich",
  "Date": "Datum",
  "Add Another": "Weitere hinzufügen",
  "Select up to": "Wählen Sie bis zu",
  "days": "Tage",
  "Recent": "Kürzlich",
  "Search Entities": "Entitäten suchen",
  "Try searching for an entity's name, or ID. You can also search for a location.": "Suchen Sie nach dem Namen oder der ID einer Entität. Sie können auch nach einem Standort suchen.",
  "Your recent search history will be shown here the next time you use search.": "Ihr letzter Suchverlauf wird hier angezeigt, wenn Sie das nächste Mal die Suche verwenden.",
  "l": "l",
  "gal": "gal",
  "L/100KM": "L/100KM",
  "MPG": "MPG",
  "KM/L": "KM/L",
  "kph": "km/h",
  "mph": "mph",
  "kph/s": "km/h/s",
  "mph/s": "mph/s",
  "m": "m",
  "ft": "ft",
  "kg": "kg",
  "lbs": "lbs",
  "°C": "°C",
  "°F": "°F",
  "square meters": "Quadratmeter",
  "square feet": "Quadratfuß",
  "square kilometers": "Quadratkilometer",
  "square miles": "Quadratmeilen",
  "kPa": "kPa",
  "psi": "psi",
  "tonne": "Tonne",
  "ton": "Tonne",
  "km": "km",
  "mi": "mi",
  "just now": "gerade eben",
  "now": "jetzt",
  "ago": "vor",
  "yesterday at": "gestern um",
  "weeks": "Wochen",
  "hours": "Stunden",
  "minutes": "Minuten",
  "seconds": "Sekunden",
  "week": "Woche",
  "day": "Tag",
  "hour": "Stunde",
  "minute": "Minute",
  "second": "Sekunde",
  "wk": "Wo.",
  "hr": "Std.",
  "min": "Min.",
  "sec": "Sek.",
  "Enter at least 2 characters to search": "Geben Sie mindestens 2 Zeichen ein, um zu suchen",
  "Keyword": "Stichwort",
  "Show by type": "Nach Typ anzeigen",
  "Find": "Finden",
  "by": "von",
  "Try searching for": "Versuchen Sie zu suchen nach",
  "Try searching by keyword.": "Versuchen Sie die Suche nach Stichwort.",
  "No matches found": "Keine Übereinstimmungen gefunden",
  "Enter atleast two characters to search": "Geben Sie mindestens zwei Zeichen ein, um zu suchen",
  "Group results": "Ergebnisse gruppieren",
  "Filter for": "Filtern nach",
  "More": "Mehr",
  "more": "mehr",
  "Drag and drop images & documents": "Bilder und Dokumente hierher ziehen",
  "Upload": "Hochladen",
  "Upload failed": "Upload fehlgeschlagen",
  "Uploads failed": "Uploads fehlgeschlagen",
  "Uploaded files have the following issues:": "Hochgeladene Dateien weisen die folgenden Probleme auf:",
  "File exceeds": "Datei überschreitet",
  "limit": "Limit",
  "is not supported. Please upload": "wird nicht unterstützt. Bitte laden Sie hoch",
  "File is empty or corrupted.": "Die Datei ist leer oder beschädigt.",
  "Network error": "Netzwerkfehler",
  "Invalid format or size.": "Ungültiges Format oder ungültige Größe.",
  "Supported formats:": "Unterstützte Formate:",
  "File Size:": "Dateigröße:",
  "MB Max": "MB max.",
  "of": "von",
  "uploaded": "hochgeladen",
  "file": "Datei",
  "files": "Dateien",
  "out of": "von",
  "Retry": "Erneut versuchen",
  "Fetch Failed": "Abruf fehlgeschlagen",
  "B": "B",
  "KB": "KB",
  "MB": "MB",
  "GB": "GB",
  "Please upload a document": "Bitte laden Sie ein Dokument hoch",
  "An error occurred with this file.": "Bei dieser Datei ist ein Fehler aufgetreten.",
  "Item": "Element",
  "image": "Bild",
  "You can only upload up to": "Sie können maximal hochladen",
  "and": "und",
  "or": "oder",
  "Unknown format": "Unbekanntes Format",
  "Please enter numeric values": "Bitte geben Sie numerische Werte ein",
  "Date format": "Datumsformat",
  "Please select a date after": "Bitte wählen Sie ein Datum nach",
  "Please select a date before": "Bitte wählen Sie ein Datum vor",
  "Please select a date between": "Bitte wählen Sie ein Datum zwischen",
  "Please select a valid date": "Bitte wählen Sie ein gültiges Datum",
  "Please enter a valid date": "Bitte geben Sie ein gültiges Datum ein",
  "Write something...": "Schreiben Sie etwas...",
  "Esc to": "Esc zum",
  "Cancel": "Abbrechen",
  "Enter": "Eingabe",
  "to": "zum",
  "Save": "Speichern",
  "Show Filters": "Filter anzeigen",
  "Hide Filters": "Filter ausblenden",
  "Show deactivated entities": "Deaktivierte Entitäten anzeigen",
  "Show deactivated": "Deaktivierte anzeigen",
  "Deactivated": "Deaktiviert",
  "No data available": "Keine Daten verfügbar",
  "Image not available": "Bild nicht verfügbar",
  "Video not available": "Video nicht verfügbar",
  "Customize Columns": "Spalten anpassen",
  "Drag to reorder. Toggle visibility with the eye icon.": "Ziehen Sie, um neu anzuordnen. Sichtbarkeit mit dem Augensymbol umschalten.",
  "Apply": "Anwenden",
  "results": "Ergebnisse",
  "Table pagination": "Tabellenpaginierung",
  "Previous page": "Vorherige Seite",
  "Next page": "Nächste Seite",
  "Press < for quick navigation": "Drücken Sie < für schnelle Navigation",
  "Press > for quick navigation": "Drücken Sie > für schnelle Navigation",
  "Last updated:": "Zuletzt aktualisiert:",
};
